export default __webpack_public_path__ + "ed188329ca1de994a08d2754a7b9ab3d.svg";